import clsx from "clsx";
import type { ComponentProps, FC } from "react";
import { useSearchParams } from "react-router-dom";
import { StatusMessage } from "src/components/StatusMessage/StatusMessage.tsx";
import { IconType } from "@spartacommodities/sparta-react-core-components";
import { SUCCCESS_DESCRIPTION, SUCCESS_BUTTON, SUCCESS_SUBTITLE, SUCCESS_TITLE } from "src/literals.ts";
import { trackGoToLoginClicked } from "src/segment";
import type { TrialType } from "../../types";
import { resultContainer, signupContainer } from "../formStyles.css.ts";

const { VITE_SPARTA_APP } = import.meta.env;

const Success: FC<Partial<ComponentProps<typeof StatusMessage>>> = ({
  icon = IconType.CHECK,
  title = SUCCESS_TITLE,
  subtitle = SUCCESS_SUBTITLE,
  description = SUCCCESS_DESCRIPTION,
  buttonText = SUCCESS_BUTTON,
  ...rest
}) => {
  const [searchParams] = useSearchParams();
  const trialType = searchParams.get("trialType") as TrialType | null;

  // The extra checks is to avoid the error when the trialType is empty
  const license = trialType && trialType.length > 0 && trialType === "curves" ? "Curves" : "Market Outlook";

  const subtitleText = trialType !== null ? `${subtitle} ${license}` : subtitle;

  const handleOnClick = () => {
    trackGoToLoginClicked(trialType);
    window.open(VITE_SPARTA_APP, "_blank");
  };
  return (
    <div className={clsx(signupContainer, resultContainer)}>
      <StatusMessage
        icon={icon}
        title={title}
        subtitle={subtitleText}
        description={description}
        buttonText={buttonText}
        onClick={handleOnClick}
        {...rest}
      />
    </div>
  );
};

export default Success;
